export const regex = {
    "email": /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
    // "password": /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,16}$/
    "password": /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/
}